import { PositioningShorthand, Tooltip } from "@fluentui/react-components";
import React, { useMemo } from "react";
import { useEllipsisTooltipStyles } from "../styles/EllipsisTooltipStyles.style";

interface EllipsisTooltipProps {
  content: string;
  className?: string;
  children: React.ReactElement | ((props: any) => React.ReactElement);
  positioning?: PositioningShorthand;
}
const defaultPositioning: PositioningShorthand = {
  position: "below",
  align: "start",
  offset: 12,
};

export const EllipsisTooltip: React.FC<EllipsisTooltipProps> = ({ content, className, children, positioning }) => {
  const styles = useEllipsisTooltipStyles();

  const mergedPositioning = useMemo(() => {
    if (typeof positioning === "object" && positioning !== null) {
      return { ...defaultPositioning, ...positioning };
    }
    return defaultPositioning;
  }, [positioning]);

  return (
    <Tooltip
      content={{
        className: className || styles.tooltipMaxWidth,
        children: content,
      }}
      relationship="label"
      positioning={mergedPositioning}
    >
      {children}
    </Tooltip>
  );
};
